module.exports = __webpack_public_path__ + "static/media/MHSBC.8ca0878e.png";